import { Components } from "@thisgorilla/primate-ds";
import { LoadingContainer } from "../../../../Common/Styles";

export const FollowersLoading = () => {
  return (
    <LoadingContainer $loadingCount={1}>
      <Components.Loading size="small" />
    </LoadingContainer>
  );
};
